import React, { useState } from 'react';
import { View, ScrollView, TouchableOpacity, Text } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import DefaultScreen from '@components/Global/DefaultScreenView';
import HRDashboard from './HRDashboard';
import EmployeeManagement from './EmployeeManagement';
import LeaveManagement from './LeaveManagement';
import AttendanceManagement from './AttendanceManagement';
import PayrollManagement from './PayrollManagement';
import PerformanceReviews from './PerformanceReviews';
import Resumes from './Resumes';
type TabKey = 'dashboard' | 'employees' | 'leave' | 'attendance' | 'payroll' | 'performance' | 'resumes';

const tabs: { key: TabKey; title: string; icon: string }[] = [
  { key: 'dashboard', title: 'Dashboard', icon: 'dashboard' },
  { key: 'employees', title: 'Employees', icon: 'people' },
  { key: 'leave', title: 'Leave', icon: 'event' },
  { key: 'attendance', title: 'Attendance', icon: 'access-time' },
  { key: 'payroll', title: 'Payroll', icon: 'attach-money' },
  { key: 'performance', title: 'Performance', icon: 'star' },
  { key: 'resumes', title: 'CV / Resumés', icon: 'folder-copy' },
];

const HRManagement = () => {
  const theme = themeSelector();
  const [activeTab, setActiveTab] = useState<TabKey>('dashboard');

  const handleTabChange = (tab: 'employees' | 'leave' | 'attendance' | 'payroll' | 'performance' | 'resumes') => {
    setActiveTab(tab);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <HRDashboard onTabChange={handleTabChange} />;
      case 'employees':
        return <EmployeeManagement />;
      case 'leave':
        return <LeaveManagement />;
      case 'attendance':
        return <AttendanceManagement />;
      case 'payroll':
        return <PayrollManagement />;
      case 'performance':
        return <PerformanceReviews />;
      case 'resumes':
        return <Resumes />;
      default:
        return <HRDashboard onTabChange={handleTabChange} />;
    }
  };

  return (
    <DefaultScreen>
      <View style={{ flex: 1 }}>
        {/* Tab Navigation */}
        <View style={{
          backgroundColor: theme ? '#ffffff' : '#1f2937',
          borderBottomWidth: 1,
          borderBottomColor: theme ? '#e5e7eb' : '#374151',
        }}>
          <ScrollView 
            horizontal 
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{ paddingHorizontal: 20 }}
          >
            {tabs.map((tab) => (
              <TouchableOpacity
                key={tab.key}
                onPress={() => setActiveTab(tab.key)}
                style={{
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  marginRight: 8,
                  borderBottomWidth: 2,
                  borderBottomColor: activeTab === tab.key 
                    ? '#3b82f6' 
                    : 'transparent',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <MaterialIcons
                  name={tab.icon as any}
                  size={20}
                  color={activeTab === tab.key 
                    ? '#3b82f6' 
                    : theme ? '#6b7280' : '#9ca3af'
                  }
                />
                <Text style={{
                  marginLeft: 8,
                  fontSize: 14,
                  fontWeight: activeTab === tab.key ? '600' : '400',
                  color: activeTab === tab.key 
                    ? '#3b82f6' 
                    : theme ? '#6b7280' : '#9ca3af'
                }}>
                  {tab.title}
                </Text>
              </TouchableOpacity>
            ))}
          </ScrollView>
        </View>

        {/* Tab Content */}
        <View style={{ flex: 1 }}>
          {renderTabContent()}
        </View>
      </View>
    </DefaultScreen>
  );
};

export default HRManagement;

